import {_utils} from "../../utils/_utils.js";
import {_libs} from "../../utils/_libs.js";
import {watchPageHeight} from "../../utils/scroll-refresh.js";

/**
 * About — "Three decades of trust" (TZ section 3): each number counts up from 0 to its value ONCE,
 * when the bottom of the screen reaches it (the whole number is in view → the full animation is seen).
 * All breakpoints. The value is typed in ACF as text ("47", "50K+", "24/7", "1000+"): only the first
 * number animates, the rest stays as is. The final value is rendered twice in PHP — a hidden sizer
 * holds the box, so the counting text never shifts the layout.
 */
const DURATION = 2.2; // s
const EASE = 'power3.out';

export const abStats = () => {
    return new Promise((resolve) => {
        _utils.initSection('.ab-stats', (section) => init(section));
        watchPageHeight();
        resolve();
    });
};

const parseValue = (raw) => {
    const match = raw.match(/\d[\d,]*(?:\.\d+)?/);
    if (!match) return null;

    const numberText = match[0];
    return {
        before: raw.slice(0, match.index),
        after: raw.slice(match.index + numberText.length),
        target: parseFloat(numberText.replace(/,/g, '')),
        decimals: (numberText.split('.')[1] || '').length,
        grouping: numberText.includes(','),
    };
};

const format = (value, {before, after, decimals, grouping}) => {
    const number = value.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: grouping,
    });
    return before + number + after;
};

const init = (section) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    section.querySelectorAll('.ab-stats__value').forEach((valueEl) => {
        const current = valueEl.querySelector('.ab-stats__value-current');
        const parsed = parseValue(valueEl.dataset.value || '');
        if (!current || !parsed || reduceMotion) return;

        const counter = {value: 0};
        const factor = 10 ** parsed.decimals;
        const render = () => {
            // round to the shown precision so the digits tick cleanly
            current.textContent = format(Math.round(counter.value * factor) / factor, parsed);
        };

        render(); // start from 0 (until the trigger fires)

        const tl = _libs._gsap({
            trigger: valueEl,
            start: 'bottom bottom', // the screen's bottom edge has passed the whole number
            once: true,
            //markers: true,
        });

        tl.to(counter, {
            value: parsed.target,
            duration: DURATION,
            ease: EASE,
            onUpdate: render,
            onComplete: () => {
                current.textContent = valueEl.dataset.value;
            },
        });
    });
};
